import { Button, Form, Input, Space } from 'antd';
import { FC } from 'react';

import { ButtonSuccess } from '@/common/components';
import { AppFormProps } from '@/common/interfaces';
import { defineInputStatus } from '@/common/utils';

import { SiteGroupFormFields, SiteGroupFormInputs, SiteGroupsSitesAutocomplete } from '@/modules/SiteGroups';

export const SiteGroupsFormView: FC<AppFormProps<typeof SiteGroupFormInputs, SiteGroupFormFields>> = ({
  formName,
  formType,
  form,
  initialValues,
  isFormLoading,
  formErrors,
  validationSchema,
  handleBack,
  handleFinish,
  handleFinishFailed
}) => {
  return (
    <Form
      form={ form }
      name={ formName }
      layout="vertical"
      initialValues={ initialValues }
      disabled={ isFormLoading }
      autoComplete="off"
      onFinish={ handleFinish }
      onFinishFailed={ handleFinishFailed }
    >
      <Form.Item
        label="Назва"
        required
        name={ SiteGroupFormInputs.Name }
        hasFeedback
        help={ formErrors?.name }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.name) }
        rules={ validationSchema.name }
      >
        <Input allowClear/>
      </Form.Item>

      <Form.Item
        label="Сайти"
        name={ SiteGroupFormInputs.SiteIds }
        hasFeedback
        extra="Показуються лише сайти з доменами та підключеним акаунтом Search Console"
        help={ formErrors?.siteIds }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.siteIds) }
        rules={ validationSchema.siteIds }
      >
        <SiteGroupsSitesAutocomplete mode="multiple"/>
      </Form.Item>

      <Form.Item wrapperCol={{ span: 24 }}>
        <Space align="center" style={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button type="default" onClick={ handleBack }>
            Скасувати
          </Button>
          <ButtonSuccess loading={ isFormLoading } type="primary" htmlType="submit">
            { formType === 'edit' ? 'Зберегти' : 'Створити' }
          </ButtonSuccess>
        </Space>
      </Form.Item>
    </Form>
  );
};
